export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";